// FUNÇÕES DE FORMATAÇÃO DA TELA DE RESTAURANTES ABERTOS (USADAS PELA TELA, PELO CARD E PELO MODAL)

export function getInitials(name = "") {
    return String(name)
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
}


// "Xh Ymin"; A PARTIR DE 24 h, "Nd Xh"
export function formatElapsed(openedAt) {
    const opened = new Date(openedAt).getTime();

    if (Number.isNaN(opened)) return "—";

    const totalMinutes = Math.max(0, Math.floor((Date.now() - opened) / 60000));
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${String(minutes).padStart(2, "0")}min`;
    return `${minutes}min`;
}


export function formatDateTime(value) {
    if (!value) return "—";

    const parsed = new Date(value);

    if (Number.isNaN(parsed.getTime())) return "—";

    return parsed.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}


export function formatTime(value) {
    if (!value) return "—";

    const parsed = new Date(value);

    if (Number.isNaN(parsed.getTime())) return "—";

    return parsed.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}


export function formatDocument(document) {
    const value = String(document ?? "");
    const digits = value.replace(/\D/g, "");

    if (digits.length === 14 && digits === value) {
        return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }

    if (digits.length === 11 && digits === value) {
        return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    }

    return value || "—";
}


export function formatCargoLabel(cargo) {
    if (!cargo) return "Sem cargo";
    if (String(cargo).toLowerCase() === "owner") return "Dono";
    return cargo;
}
